import $ from 'jquery';

class MainNav {
  constructor() {
    this.header = $('.js-header');
    this.mainNav = $('.js-main-nav');
    this.mainNavItems = $('.js-main-nav-items, .js-main-nav .mega-menu-wrap');
    this.mainNavLink = this.mainNavItems.find('li > a');
    this.dropdown = this.mainNav.find('.sub-menu');
    this.mainNavToggleBtn = this.mainNav.find('.js-main-nav-toggle');
    this.megamenuWrap = $('.mega-menu-wrap');

    this.breakpoint = window.matchMedia('(max-width: 1024px)');

    this.megamenuTweaks();

    $(window).on('load', () => {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;

      this.dropdownsPosition();
      this.navToggle();
      this.accessibility();
      this.mobileNav();
      this.mobileDropdowns();
      this.stickyHeader();
    });

    let debounce;
    $(window).on('resize', () => {
      clearTimeout(debounce);

      debounce = setTimeout(() => {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;

        this.dropdownsPosition();
        this.navToggle();
        this.mobileNav();
        this.mobileDropdowns();
        this.stickyHeader();
      }, 250);
    });
  }

  megamenuTweaks() {
    this.megamenuShortRow = $('.mega-menu-row.short-row');

    if (this.megamenuShortRow) {
      $.each(this.megamenuShortRow, (i, el) => {
        const row = $(el);
        row.parent().addClass('short-row-menu');
      });
    }

    if (this.breakpoint.matches && this.megamenuWrap.length) {
      const ps = this.megamenuWrap.find('p');
      const titles = this.megamenuWrap.find('.mega-block-title');

      if (ps.length) {
        $.each(ps, (i, p) => {
          if (
            $(p)
              .html()
              .replace(/\s|&nbsp;/g, '').length === 0
          ) {
            $(p).remove();
          }
        });
      }

      if (titles.length) {
        $.each(titles, (i, t) => {
          if ($(t).html() === '.') {
            if (
              $(t)
                .parent()
                .text()
                .trim() === '.'
            ) {
              $(t)
                .parent()
                .remove();
            }
            $(t).remove();
          }
        });
      }
    }
  }

  dropdownsLoading() {
    this.dropdownContainer.removeClass('is-loading');
  }

  dropdownsPosition() {
    if (!this.dropdown.length) {
      return;
    }

    // Must Show to get offset
    this.dropdown.css({ display: 'flex', opacity: 0 });

    this.dropdown.removeClass('c-main-nav__dropdown--reverse');

    this.dropdown.each((index, element) => {
      const dropdown = $(element);
      const offsetLeft = dropdown.offset().left;
      const width = dropdown.width();
      const offsetRight = offsetLeft + width;

      if (offsetRight > this.windowWidth) {
        dropdown.addClass('c-main-nav__dropdown--reverse');
      }
    });

    // Hide after getting offset
    this.dropdown.css({ display: '', opacity: 1 });
  }

  mobileNav() {
    if (this.windowWidth < 1024) {
      const headerHeight = this.header.outerHeight();
      this.mainNavItems.css({
        top: headerHeight,
        height: this.windowHeight - headerHeight,
      });
    } else {
      this.mainNavItems.css({
        top: 'auto',
        height: 'auto',
      });
    }
  }

  mobileDropdowns() {
    this.mainNavLink.off('click');
    this.mainNavLink.on('click', e => {
      const self = $(e.currentTarget);

      if (this.windowWidth < 1024) {
        const dropdown = self.next('.sub-menu');
        this.dropdown.not(dropdown).slideUp();

        if (dropdown.length) {
          e.preventDefault();
          dropdown.slideToggle();
        }
      }
    });
  }

  accessibility() {
    this.mainNavLink.on('focus', e => {
      const self = $(e.currentTarget);

      this.mainNavLink.parent().removeClass('has-dropdown-open');
      self.parent().addClass('has-dropdown-open');
    });

    this.mainNavLink.on('mouseover', () => {
      this.mainNavLink.parent().removeClass('has-dropdown-open');
    });
  }

  navToggle() {
    this.mainNavToggleBtn.off('click');
    this.mainNavToggleBtn.on('click', e => {
      const self = $(e.currentTarget);

      self.toggleClass('is-active');
      this.mainNav.toggleClass('is-open');
      this.mainNavItems.toggleClass('is-open');
    });
  }

  stickyHeader() {
    const headerHeight = this.header.outerHeight();

    $('body').css('padding-top', headerHeight);
  }
}

export default new MainNav();



// WEBPACK FOOTER //
// ./src/scripts/modules/main-nav-new.js